<h2>{{'REGIONAL-OFFICER.TITLE' | translate}}</h2>

<div class="col-xs-12" >

  <button type="submit" class="btn btn-primary" style="float: right;"
    (click)="saveRegionalOfficerSettings()">{{'FUNCTION-BUTTONS.SAVE' | translate}}
  </button>
</div><br />
@for (service of services; track service) {
  <div style="padding: 10px 20px 20px 10px;">
    <h3>{{service.name}}</h3>
    @if (items) {
      <ntr-multiple-select [items]="items[service.id]"
        [activeItems]="activeItems[service.id]"
        (onUpdate)="updateActiveItems($event,service.id)"
      [placeholder]="'Set datasets'"></ntr-multiple-select>
    }
  </div>
}